import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import AdminLayout from "./components/AdminLayout";
import { RequireAuth, RequireAdmin } from "./context/AuthContext";

import Home from "./pages/Home";
import ProductInfo from "./pages/ProductInfo";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Support from "./pages/Support";
import AboutUs from "./pages/AboutUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import FAQ from "./pages/FAQ";
import NotFound from "./pages/NotFound";

import Wallet from "./user/Wallet";
import Profile from "./user/Profile";
import Orders from "./user/Orders";
import ViewOrder from "./user/ViewOrder";

import AdminDashboard from "./admin/AdminDashboard";
import ReviewQueue from "./admin/ReviewQueue";
import AdminOrders from "./admin/AdminOrders";
import AdminProducts from "./admin/AdminProducts";
import AdminProductEdit from "./admin/AdminProductEdit";
import AdminProductCreate from "./admin/AdminProductCreate";
import AdminUsers from "./admin/AdminUsers";
import AdminBanners from "./admin/AdminBanners";
import AdminOffers from "./admin/AdminOffers";
import AdminPaymentLogs from "./admin/AdminPaymentLogs";
import AdminAnnounce from "./admin/AdminAnnounce";
import AdminAudit from "./admin/AdminAudit";
import AdminOrderDetail from "./admin/AdminOrderDetail";
import Leaderboard from "./pages/Leaderboard";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="game/:id" element={<ProductInfo />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="support" element={<Support />} />
        <Route path="about" element={<AboutUs />} />
        <Route path="privacy" element={<PrivacyPolicy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="faq" element={<FAQ />} />
        <Route path="leaderboard" element={<Leaderboard />} />

        <Route path="wallet" element={<RequireAuth><Wallet /></RequireAuth>} />
        <Route path="profile" element={<RequireAuth><Profile /></RequireAuth>} />
        <Route path="orders" element={<RequireAuth><Orders /></RequireAuth>} />
        <Route path="orders/:orderId" element={<RequireAuth><ViewOrder /></RequireAuth>} />
      </Route>

      <Route path="admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
        <Route index element={<AdminDashboard />} />
        <Route path="review" element={<ReviewQueue />} />
        <Route path="orders" element={<AdminOrders />} />
        <Route path="orders/:orderId" element={<AdminOrderDetail />} />
        <Route path="products" element={<AdminProducts />} />
        <Route path="products/new" element={<AdminProductCreate />} />
        <Route path="products/:id" element={<AdminProductEdit />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="banners" element={<AdminBanners />} />
        <Route path="offers" element={<AdminOffers />} />
        <Route path="payments" element={<AdminPaymentLogs />} />
        <Route path="announce" element={<AdminAnnounce />} />
        <Route path="audit" element={<AdminAudit />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}